import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormGroup } from 'react-nice-inputs';
import DataService from '../../modules/dataservice';
import ReCAPTCHA from 'react-google-recaptcha';
import moment from 'moment';
import { createSessionExpiredCookie } from './AccountsExpirationSessionCookie';

const currentEnviroment = window._app.results.environment;
const isSandals = window._app.brandOptions.isSandals;
const brandName = isSandals ? 'sandals' : 'beaches';
const tstUrl = isSandals ? 'https://v13.sandals.com/my-account/' : 'https://v12.beaches.com/my-account/';
const urlBase = currentEnviroment === 'TST' ? tstUrl : `https://${brandName}.com/my-account/`;

class Accounts extends Component {
  constructor(props) {
    super(props);

    this.accountsRecaptcha = React.createRef();
  }

  state = {
    email: '',
    password: '',
    captcha: '',
    staySignedIn: false,
    showPassword: false,
    requiredCaptcha: false,
    requiredPassword: false,
    requeiredUser: false,
    loading: false,
    errorInputs: false,
    errorMsg: '',
    returnToGuest: false,
    contentEqual: true,
    verificationLoading: false,
    passwordPendingChange: false,
  }

  accountInformationLoad = (accountsResponse, accountPointsResponse) => {
    if(accountsResponse.status === 200 && accountPointsResponse.status === 200) {
      const profilesData = accountsResponse.content;
      const responseData = profilesData.primary_member;
      const addressData = responseData.Address;
      const pointsData = accountPointsResponse.content;
      const formattedBirth = responseData.birth_date ? moment.utc(new Date(responseData.birth_date)).format('YYYY-MM-DD') : '';
      const accountDataRequired = {
        accountNumber: profilesData.account_number || '',
        title: responseData.title || '',
        gender: responseData.gender || '',
        firstName: responseData.first_name || '',
        lastName: responseData.last_name || '',
        dateOfBirth: formattedBirth || '',
        address1: addressData.address1 || '',
        address2: addressData.address2 || '',
        city: addressData.city || '',
        state: addressData.state || '',
        country: addressData.country_code || '',
        zipCode: addressData.zip_code || '',
        phoneNumber: responseData.mobile_phone_number || responseData.landline_phone_number || responseData.landline_phone_number2 || '',
        tier: profilesData.member_level || '',
        email: responseData.email || '',
        points: pointsData.points_available || 0,
      };

      return accountDataRequired;
    }

    return {};
  };

  returnToGuestStep = async(accountsResponse, accountPointsResponse) => {
    const accountDataRequired = this.accountInformationLoad(accountsResponse, accountPointsResponse);
    const summaryResponse = await DataService.readSummary();

    if(Object.keys(accountDataRequired).length > 0) {
      const sandalsAccountResponse = await DataService.setSandalsAccountCookie(accountDataRequired);

      console.log('Process Sandals Accounts:', sandalsAccountResponse.code ? 'Success' : 'Fail');

      const step = window._app.page.step;

      if(step === 5) {
        const requiredFields = [
          'firstName',
          'lastName',
          'dateOfBirth',
          'address1',
          'city',
          'state',
          'country',
          'zipCode',
          'phoneNumber',
          'email'
        ];

        const {content = {}} = summaryResponse;
        const {guestsData = {}} = content;
        const {firstName, lastName, email} = guestsData;
        const {firstName: accountFN, lastName: accountLN, email: accountEmail} = accountDataRequired;
        const returnToGuest = requiredFields.every((name) => accountDataRequired[name] === '');
        const contentEqual = firstName.toLowerCase() === accountFN.toLowerCase && lastName.toLowerCase() === accountLN.toLowerCase() && email.toLowerCase() === accountEmail.toLowerCase();

        createSessionExpiredCookie(0);
        if(!returnToGuest && contentEqual) {
          window.location.reload();
        }
        this.setState({returnToGuest: returnToGuest, contentEqual: contentEqual});
      } else {
        createSessionExpiredCookie(0);
        window.location.reload();
      }
    } else {
      const statusError = 'The requested resource is not available at this time. Please try again later.';

      this.setState({loading: false, errorInputs: true, errorMsg: statusError});
    }
  };

  loadAccountCookieInformation = async(accountsResponse, accountPointsResponse) => {
    const accountDataRequired = this.accountInformationLoad(accountsResponse, accountPointsResponse);

    if(Object.keys(accountDataRequired).length > 0) {
      const sandalsAccountResponse = await DataService.setSandalsAccountCookie(accountDataRequired);

      console.log('Process Sandals Accounts:', sandalsAccountResponse.code ? 'Success' : 'Fail');
    }
  };

  _loginAccounts = async() => {
    const loginData = this.state;
    const {email, password} = loginData;

    const emailRegx = /^[\w-\.]+@([\w-]+\.)+[\w-]{4,256}$/gi;
    const userRegx = /^[-.@_a-zA-Z0-9]+$/gi;

    const validEmail = emailRegx.test(email) || userRegx.test(email);
    const validPassword = password.length > 0;

    if(validEmail && validPassword) {
      this.setState({loading: true});
      const updateLoginData = {... this.state};

      const responseStatus = await DataService.loginToAccounts(updateLoginData);

      if(Object.keys(responseStatus).length > 0) {
        const { status, content } = responseStatus;

        if(content.passwordPendingChange) {
          window.location = `${urlBase}forgot-password?isInvalid`;
        }

        switch(status) {
          case 200:
            const accountsResponse = await DataService.getPrimaryAccount();
            const accountPointsResponse = await DataService.getAccountPoints();

            this.returnToGuestStep(accountsResponse, accountPointsResponse);
            break;

          default:
            let errorMsg = '';

            switch(status) {
              case 400:
                errorMsg = 'The requested resource is not available at this time. Please try again later.';
                break;
              case 403:
                errorMsg = 'Account needs to be enabled.';
                break;
              case 503:
                errorMsg = 'We are currently experiencing problems loading your account, please try again later.';
                break;
              case 498:
                errorMsg = 'Your session has been terminated. Please log in again.';
                break;
              case 500:
                errorMsg = 'The requested resource is not available at this time. Please try again later.';
                break;
              default:
                errorMsg = 'Invalid user credentials. The email or password you entered is incorrect.';
                break;
            }
            if(content.maxAttemps) {
              this.setState({requiredCaptcha: true, loading: false});
            }

            if(this.state.requiredCaptcha) {
              this.accountsRecaptcha.current.reset();
              this.setState({captcha: ''});
            }

            this.setState({loading: false, requiredPassword: true, requeiredUser: true, errorMsg: errorMsg, errorInputs: true});
            break;
        }
      } else {
        const errorMsg = 'The requested resource is not available at this time. Please try again later.';

        this.setState({loading: false, requiredPassword: !validPassword, requeiredUser: !validEmail, errorInputs: true, errorMsg: errorMsg});
      }
    }else {
      const errorMsg = 'Invalid user credentials. The email or password you entered is incorrect.';

      this.setState({requiredPassword: !validPassword, requeiredUser: !validEmail, errorInputs: true, errorMsg: errorMsg});
    }
  }

  _setInputValue = (name, value) => {
    if(name === 'captcha') {
      const noError = value.length > 0;

      this.setState({[name]: value ? value : '', errorInputs: !noError, requeiredUser: !noError, requiredPassword: !noError});
    } else {
      this.setState({[name]: value, requiredPassword: false, requeiredUser: false, errorInputs: false});
    }
  }

  _showPassword = () => {
    const {showPassword} = this.state;

    this.setState({showPassword: !showPassword});
  }

  _returnToGuestStep = () => {
    this.setState({verificationLoading: true});
    window.location = `/guests/?subSessionId=${ window._app.results.subSessionId }`;
  }

  render() {
    const {brand, showLogin} = this.props;
    const beachesDesctiption = 'Receive points & exclusive gifts with the our Loyalty Program! Modify your preferences, find your point rewards, follow up with your trips and much more.';
    const sandalsDescription = 'Receive points & exclusive gifts with Sandals Select Rewards! Modify your preferences, find your point rewards, follow up with your trips and much more.';
    const description = isSandals ? sandalsDescription : beachesDesctiption;
    const { showPassword, requiredPassword, requeiredUser, requiredCaptcha, loading, errorMsg, errorInputs, returnToGuest, contentEqual, verificationLoading } = this.state;
    const notMatching = returnToGuest || !contentEqual;

    return (
      <Fragment>
        {showLogin &&
          <section className="accounts-section apply-login-sticky">
            <div className="login">
              <h4 className="title">Sign in</h4>
              <FormGroup type="text"
                name="email"
                boxClassList={!requeiredUser ? ['email-input', 'full-width'] : ['email-input', 'is-invalid', 'full-width']}
                onChange={(name, value) => this._setInputValue(value, name)}
                attrs={{placeholder: 'Email Address', maxLength: 50}}
              />
              <div className="password-container">
                <FormGroup type={!showPassword ? 'password' : 'text'}
                  name="password"
                  boxClassList={ !requiredPassword ? ['password-input', 'full-width'] : ['password-input', 'is-invalid', 'full-width'] }
                  onChange={ (name, value) => this._setInputValue(value, name) }
                  attrs={{ placeholder: 'Password', maxLength: 50 }}
                />
                <i onClick={this._showPassword} className={!showPassword ? 'icon-eye' : 'icon-eye-closed'}/>
              </div>
              <div className="stay-signed">
                <FormGroup
                  type="checkbox"
                  onChange={(name, value) => this._setInputValue(value, name)}
                  classList={['stay-signed-checkbox', 'check-alt']}
                  options={[{label: (<span>Stay signed in</span>), value: 'signed'}]}
                  value={['signed']}
                  name="signed-opt"
                />
              </div>
              {requiredCaptcha &&
                <div className="recaptcha-wrapper">
                  <ReCAPTCHA
                    ref={this.accountsRecaptcha}
                    className="g-recaptcha"
                    name="recaptchaToken"
                    sitekey="6LdfKGIqAAAAAHm8PIztlqg7IJplWS4B1n_wDivW"
                    onChange={(value) => this._setInputValue('captcha', value)}
                  />
                </div>
              }
              {errorInputs &&
                <div className="required-credentials">
                  <p className="required">{errorMsg}</p>
                </div>
              }
              {!loading &&
                <button className="sign-in" onClick={this._loginAccounts}>Sign in to Account</button>
              }
              {loading &&
                <div className="loader-container">
                  <div className="sign-in-loader"/>
                </div>
              }
              <p className="forgot-info">Recover <a href={`${urlBase}forgot-username`} target="_blank">Username</a> or <a href={`${urlBase}forgot-password` } target="_blank">Password</a></p>
            </div>
            <div className="line-divider" />
            <div className={`information ${!isSandals ? 'beaches' : ''}`}>
              <h4 className="title">Join {brand}</h4>
              <p className="description">
                {description}
              </p>
              <a className="create-account" href={`${urlBase}register`} target="_blank">Create your {brand} account <i className="icon-arrow"/> </a>
            </div>
          </section>
        }
        {notMatching &&
          <div className="sign-out-warning">
            <div className="content">
              <div className="information">
                <p className="question">The information provided on the booking must match with the information on the Sandals Account.</p>
                <p className="message">We will return you to the Guest step with the information of your Sandals Account.</p>
              </div>
              <div className="options">
                {!verificationLoading &&
                  <button className="continue" onClick={this._returnToGuestStep}>Continue</button>
                }
                {verificationLoading &&
                <div className="loader-container">
                  <div className="sign-in-loader"/>
                </div>
                }
              </div>
            </div>
          </div>
        }
      </Fragment>
    );
  }
}

// passwordPendingChange

Accounts.propTypes = {
  brand: PropTypes.string,
  showLogin: PropTypes.bool,
};

Accounts.defaultProps = {
  brand: 'Sandals',
  showLogin: false,
};

export default Accounts;



// WEBPACK FOOTER //
// ./js/components/global/Accounts.js